import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import AuditReports from "@/components/audit/AuditReports";
import { TableSkeleton } from "@/components/ui/Skeleton";
import { trpc } from "@/lib/trpc";
import { useAuditAccountId } from "./$orgSlug.audit";

// The Reports tab: the account's Reports, each opening the Report page.
export const Route = createFileRoute("/_authenticated/$orgSlug/audit/")({
  component: ReportsTab,
});

function ReportsTab() {
  const { orgSlug } = Route.useParams();
  const accountId = useAuditAccountId();
  const { data } = useQuery(trpc.audit.reports.queryOptions({ orgSlug, accountId }));
  return data ? (
    <AuditReports orgSlug={orgSlug} reports={data.reports} />
  ) : (
    <TableSkeleton label="Loading Reports" rows={6} columns={3} />
  );
}
